import { createAction, props } from '@ngrx/store';
import {
  IListParentRequest,
  IParent,
  IParentListResponse,
} from '../../models/parent.model';
import { WritableSignal } from '@angular/core';

// Load Multiple Parents
const loadParentsList = createAction(
  '[Parent] Load Parents List'
  // props<{ page: number; limit: number; search?: string | null; isActive?: boolean | null }>()
);
const loadParentsListSuccess = createAction(
  '[Parent] Load Parents List Success',
  props<{ response: IParentListResponse; filter?: IListParentRequest }>()
);
const loadParentsListFailure = createAction(
  '[Parent] Load Parents List Failure',
  props<{ error: string }>()
);

// Load Single Parent
const loadSingleParent = createAction(
  '[Parent] Load Single Parent',
  props<{ id: string }>()
);
const loadSingleParentSuccess = createAction(
  '[Parent] Load Single Parent Success',
  props<{ parent: IParent }>()
);
const loadSingleParentFailure = createAction(
  '[Parent] Load Single Parent Failure',
  props<{ error: string }>()
);

const createParent = createAction(
  '[Parent] Create Parent',
  props<{ parent: IParent; closeModalSignal: WritableSignal<boolean> }>()
);
const createParentSuccess = createAction(
  '[Parent] Create Parent Success',
  props<{ parent: IParent }>()
);
const createParentFailure = createAction(
  '[Parent] Create Parent Failure',
  props<{ error: string }>()
);

// Update Parent
const updateParent = createAction(
  '[Parent] Update Parent',
  props<{
    id: string;
    parent: Partial<IParent>;
    closeModalSignal: WritableSignal<boolean>;
  }>()
);
const updateParentSuccess = createAction(
  '[Parent] Update Parent Success',
  props<{ parent: IParent }>()
);
const updateParentFailure = createAction(
  '[Parent] Update Parent Failure',
  props<{ error: string }>()
);

// Delete Parent
const deleteParent = createAction(
  '[Parent] Delete Parent',
  props<{ id: string; closeModalSignal: WritableSignal<boolean> }>()
);
const deleteParentSuccess = createAction(
  '[Parent] Delete Parent Success',
  props<{ id: string }>()
);
const deleteParentFailure = createAction(
  '[Parent] Delete Parent Failure',
  props<{ error: string }>()
);

// Change Parent Status
const changeParentStatus = createAction(
  '[Parent] Change Parent Status',
  props<{ id: string; fetchClients?: boolean }>()
);
const changeParentStatusSuccess = createAction(
  '[Parent] Change Parent Status Success',
  props<{ id: string; fetchClients?: boolean }>()
);
const changeParentStatusFailure = createAction(
  '[Parent] Change Parent Status Failure',
  props<{ error: string }>()
);

const clearCurrentParent = createAction('[Parent] Clear Current Parent');

const setParentQueryParams = createAction(
  '[Client] Set Query Params',
  props<IListParentRequest>()
);

// Selected Parent
const selectParent = createAction(
  '[Parent] Select Parent',
  props<{ id: string; withRedirect?: boolean }>()
);
const selectParentSuccess = createAction(
  '[Parent] Select Parent Success',
  props<{ parent: IParent; withRedirect?: boolean }>()
);
const selectParentFailure = createAction(
  '[Parent] Select Parent Failure',
  props<{ error: string }>()
);

const clearSelectedParent = createAction('[Parent] Clear Selected Parent');

const setActiveTab = createAction(
  '[Parent] Set Active Tab',
  props<{ tab: number }>()
);

export const ParentActions = {
  loadParentsList,
  loadParentsListSuccess,
  loadParentsListFailure,
  loadSingleParent,
  loadSingleParentSuccess,
  loadSingleParentFailure,
  // getSingleParent,
  // getSingleParentSuccess,
  // getSingleParentFailure,
  createParent,
  createParentSuccess,
  createParentFailure,
  updateParent,
  updateParentSuccess,
  updateParentFailure,
  deleteParent,
  deleteParentSuccess,
  deleteParentFailure,
  changeParentStatus,
  changeParentStatusSuccess,
  changeParentStatusFailure,
  clearCurrentParent,
  setParentQueryParams,
  selectParent,
  selectParentSuccess,
  selectParentFailure,
  clearSelectedParent,
  setActiveTab
};
